export const set = property => (state, payload) => (state[property] = payload)

export const toggle = property => state => (state[property] = !state[property])

export default {
  setDrawer: set('drawer'),
  setResponsive: set('responsive'),
  setLoggedIn: set('is_logged'),
  setAlert: set('show_alert'),
  setAlertColor: set('alert_color'),
  setAlertText: set('alert_text'),
  setTodaysTransactions: set('todays_transactions'),
  setQuedTransactions:set('qued_transactions'),
  setMonthSales: set('month_sales'),
  setCredits: set('credits'),
  setMonthDailySales: set('month_daily_sales'),
  setSupplies: set('supplies'),
  setTodaysFishcars:set('todays_fishcars'),
  setSequence: set('sequence'),
  setFishcarDailySales: set('fishcar_daily_sales'),
  setMidprice: set('midprice'),
  setIncomeSourceSummary: set('income_source_summary'),
  setSalesSummary: set('sales_summary'),
  setKilosToDistribute: set('kilos_to_distribute'),
}
